/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Dropdown, Modal, Icon, Button } from 'semantic-ui-react';

import { stopPropagation } from '../../../../../../utils';

class ProjectedActivityDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async deleteDocument(id) {
    try {
      const { deleteProjectedLinkedActivity, currentActivity } = this.props;
      await deleteProjectedLinkedActivity(currentActivity.id, id);
      this.toggle();
    } catch (error) {
      // handle error here
      throw error(error);
    }
  }

  render() {
    const { modal } = this.state;
    const { activity, deleteLinkedActivitiesLoading, t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <Dropdown.Item className="activity-actions-dropdown-delete">
            <label className="activity-actions-text red-text">
              {t('actions.remove')}
            </label>
          </Dropdown.Item>
        }
      >
        <Modal.Header>
          {t('activity.activity_plan.linked_activity.delete_activity', {
            name: activity.name,
          })}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t(
              'activity.activity_plan.linked_activity.delete_projected_activity_confirmation'
            )}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => this.toggle()}
            className="activity-activation-cancel-btn"
          >
            {t('actions.no')}
          </Button>
          <Button
            loading={deleteLinkedActivitiesLoading}
            disabled={deleteLinkedActivitiesLoading}
            // className="delete-proceed-btn"
            onClick={() => this.deleteDocument(activity.id)}
            // positive
            // labelPosition="right"
            // icon="checkmark"
            className="new-collective-save-btn"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

ProjectedActivityDelete = withTranslation()(ProjectedActivityDelete);
export default ProjectedActivityDelete;
